import React, { useEffect } from "react";
import {
  Backdrop,
  Button,
  CustomInput,
  CustomSelect,
  FormFieldSet,
  LogoLoader,
  NewTable,
  NewTableAdv,
  useFormHandler,
} from "../../../../../components";
import { dateFormator, getClientId, mapTableRows } from "../../../../../utils";
import { openinvoicedata } from "../../../../../assets/data/candidatesData";
import {
  DropDownFilteroptions,
  upcommingpayfrequency,
} from "../../../../../assets/data/projectData";
import { useDispatch, useSelector } from "react-redux";
import {
  clearInvoicesdata,
  getAllInvoicesStart,
} from "../../../../../redux/slices/invoices/invoicesSlice";
import { usePagination } from "../../../../../hooks";
import dayjs from "dayjs";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
const OpenInvoices = ({clientId}) => {
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.invoices?.data || 0;
  const { allInvoices } = useSelector((state) => state.invoices);
  console.log("allIncoices", allInvoices.data);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Search: "",
    InvoiceDate: "",
  });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10
    // (newPage, newLimit) => {
    //   dispatch(
    //     getClientsStart({
    //       page: newPage,
    //       limit: newLimit,
    //       filter: {},
    //       sort: { uiid: -1 },
    //       // sort: { uiid: 1 },
    //       ret: "uiid businessName generalInfo email contact placements jobCode recordStatus",
    //       ref: "PlacementWithEmp",
    //       incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
    //     })
    //   );
    // }
  );
  useEffect(() => {
    if (clientId) {
      dispatch(
              totalCountStart({
                collection: "invoices",
                coll: "Invoice",
                filters: {
                  clientId: {
                    type: "NONE",
                    value: clientId,
                  },
          dueDate: { type: "GT", value: dayjs().startOf('day') }
                },
              })
            );
      
      dispatch(
        getAllInvoicesStart({
        limit,
        page,
          filters: {
            search: {
            type:"SEARCH",value: formData.Search,
          },
          clientId: {
            type: "NONE", value: clientId,
          },
          dueDate: { type: "GT", value: dayjs().startOf('day') }
        },
        coll: "Invoice",
        // ret:"uiid"
        ret: "invoiceNum employeeId clientId invoiceDate shippedDate dueDate amounts currency dueDate uiid memo qbSync",
        ref: "Client Employee",
        incl: ["businessName uiid", "firstName lastName"],
      })
    );
  }
    return () => {
      dispatch(clearInvoicesdata());
    };
  }, [clientId,limit,page,formData.Search]);
  
  const tableData2 = allInvoices?.data?.map((item) => ({
    invoiceNumber: item?.invoiceNum || "",
    employee: item?.employeeId 
      ? `${item.employeeId.firstName || ""} ${item.employeeId.lastName || ""}` 
      : "-",
    client: item?.clientId?.businessName || "-",
    clientID: item?.clientId?.uiid ? getClientId(item.clientId.uiid) : "-",
    invoiceDate: dateFormator(item?.invoiceDate, "month-day-year"),
    shippedDate: dateFormator(item?.invoiceDate, "month-day-year"),
    invoiceDueDate: dateFormator(item?.dueDate, "month-day-year"),
    invoicedAmount: item?.amounts?.invoiced ? `${item.amounts.invoiced} USD` : "-",
    receivedAmount: item?.amounts?.received ? `${item.amounts.received} USD` : "-",
  }));

  const tableData = openinvoicedata;
  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
    },
    {
      key: "employee",
      label: "Employee",
    },
    {
      key: "client",
      label: "Client",
    },
    {
      key: "clientID",
      label: "Client ID",
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
    },
    {
      key: "shippedDate",
      label: "Shipped Date",
    },
    {
      key: "invoiceDueDate",
      label: "InvoiceDueDate",
    },
    {
      key: "invoicedAmount",
      label: "Invoiced Amount",
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
    },

    // {
    //   key: "recordType",
    //   label: "Record Type",
    // },
  ];
  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);
  return (
    <>
      {/* <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop> */}
      <NewTableAdv
        rows={mappedRows}
        columns={columns}
        showSlNo
        totalCount={totalCount}
        serverPagination={true}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: false,
          filter: true,
          download: false,
          add: [
            {
              component: (
                <div className="flex gap-3">
                  <div className="min-w-[200px] mt-0.5">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder=" Invoice No,Employee"
                      value={formData.Search}
                      onChange={(value) => handleChange("Search", value)}
                      size="sm"
                    />
                  </div>
                  <div className="min-w-[200px]">
                    <FormFieldSet
                      type="select"
                      title="Invoice Date"
                      placeholder="Select InvoiceDate"
                      value={formData.InvoiceDate}
                      onChange={(value) => handleChange("InvoiceDate", value)}
                      options={DropDownFilteroptions}
                      size="sm"
                    />
                  </div>
                  <div className="flex justify-end items-end mb-1.5" >
                    <Button title="Search" size="sm" />
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
    </>
  );
};

export default OpenInvoices;
